import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import DropdownMenu from '../../../../../components/DropdownMenu';
import FormInput from '../../../../../components/form/FormInput';
import InputLabel from '../../../../../components/form/InputLabel';
import { hideModal, updateModalOptions } from '../../../../../redux/modules/modal';
import { globalRequirementTemplateBuilder } from '../../../../../redux/reducer';

function ReopenArchivedTemplateModal({ templateId }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(globalRequirementTemplateBuilder.getRequirementTemplate(templateId));

    return () => dispatch(globalRequirementTemplateBuilder.resetSelectedTemplate());
  }, [dispatch, templateId]);

  const template = useSelector(globalRequirementTemplateBuilder.selectCurrentRequirementTemplate);
  const folders = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplateFolders).data;
  const [selectedFolder, setTemplateFolder] = useState();

  const useFormMethods = useForm();
  const { handleSubmit, reset } = useFormMethods;

  useEffect(() => {
    if (template) {
      const defaultValues = { name: template.name };
      reset(defaultValues);
    }
  }, [reset, template]);

  const handleFolderSelect = selectedItem => {
    const selected = { name: selectedItem.label, id: selectedItem.value };
    setTemplateFolder(selected);

    if (!selectedFolder) {
      dispatch(updateModalOptions({ buttons: { primaryButtonOptions: { isDisabled: false } } }));
    }
  };

  const onSubmit = async data => {
    const templateData = selectedFolder
      ? {
        name: data.name,
        requirement_template_folder_id: Number(selectedFolder.id),
        published_at: new Date(),
        archived_at: null
      }
      : { name: data.name, published_at: null, archived_at: null, updated_at: new Date() };

    await dispatch(globalRequirementTemplateBuilder.updateRequirementTemplate(templateId, templateData));
    dispatch(globalRequirementTemplateBuilder.listArchivedRequirementTemplates());
    dispatch(globalRequirementTemplateBuilder.listRequirementTemplateFolders());
    dispatch(hideModal());
  };

  return (
    <form id="reopenArchivedTemplate" onSubmit={handleSubmit(onSubmit)}>
      <FormInput
        isDisabled
        required
        inputName="name"
        labelName="Template Name"
        placeholder="Template Name"
        useFormMethods={useFormMethods}
      />
      <Box mb="26px">
        <InputLabel
          required
          labelName="Folder"
          toolTip="If no folder is selected, the reopened template will go to Drafts folder"
        />
        <DropdownMenu
          idKey="id"
          labelKey="name"
          options={folders}
          selected={selectedFolder?.name}
          width="424px"
          onSelect={handleFolderSelect}
        />
      </Box>
    </form>
  );
}

ReopenArchivedTemplateModal.propTypes = {
  templateId: PropTypes.number.isRequired
};

export default ReopenArchivedTemplateModal;
